import dynamic from "next/dynamic";

export const NoSSRComponent = <T = any>(Component: React.FC<T>) => dynamic(() => Promise.resolve(Component), { ssr: false }) as typeof Component;
